// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__7eqX4","letter":"Logo_letter__7AApM"};